import React from "react";
import styles from "../styles/WorkPage.module.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ProjectCard from "../components/ProjectCard";
import projectsData from "../data/projectsData";
import 'react-loading-skeleton/dist/skeleton.css';
import CTASection from "../components/CTASection";

const TestimonialAvatar = ({ src, alt }) => (
  <img
    src={src}
    alt={alt}
    className={styles.clientAvatar}
    loading="lazy"
  />
);

const WorkPage = () => {

  return (
    <div className={styles.workPage}>
      <Navbar />

      <section className={`${styles.heroSection} section-container`}>
        <div className={styles.portfolioBadge}>Portfolio</div>
        <h1 className={styles.heroTitle}>
          Our Success Stories and Featured Projects
        </h1>
        <p className={styles.heroDescription}>
          Explore our portfolio of innovative digital solutions that have helped
          businesses transform and grow.
        </p>
        <div className={styles.statsContainer}>
          <div className={styles.statCard}>
            <div className={styles.statNumber}>17+</div>
            <div className={styles.statLabel}>Projects Delivered</div>
          </div>
          <div className={styles.statCard}>
            <div className={styles.statNumber}>10+</div>
            <div className={styles.statLabel}>Global Clients</div>
          </div>
          <div className={styles.statCard}>
            <div className={styles.statNumber}>95%</div>
            <div className={styles.statLabel}>Client Retention</div>
          </div>
        </div>
      </section>

      <section className="flex flex-wrap gap-3 md:px-16 px-4 items-center justify-center mb-20 section-container">
  {projectsData.map((project, idx) => (
    <div key={idx} className="flex-shrink-0 w-[300px]"> {/* fixed width for wrapping */}
      <ProjectCard {...project} />
    </div>
  ))}
</section>


      <section className={`${styles.testimonialSection} section-container`}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Client Success Stories</h2>
          <p className={styles.sectionDescription}>
            Real impact and measurable results for our clients.
          </p>
        </div>
        <div className={styles.testimonialCards}>
          <div className={styles.testimonialCard}>
            <div className={styles.clientInfo}>
              <TestimonialAvatar src="/ProjectsSnapshots/Pushti Amritulya/LOGO.png" alt="TechFlow" />
              <div>
                <div className={styles.clientName}>Pushti Amrittulya</div>
                <div className={styles.clientIndustry}>Franchise Portfolio</div>
              </div>
            </div>
            <p className={styles.testimonialText}>
              "The platform increased our operational efficiency by 40% ."
            </p>
            <div className={styles.resultMetric}>
              <div className={styles.metricLabel}>Revenue Growth</div>
              <div className={styles.metricValue}>+150%</div>
            </div>
          </div>

          <div className={styles.testimonialCard}>
            <div className={styles.clientInfo}>
              <TestimonialAvatar src="ProjectsSnapshots/Shri Balaji Cement Product/shrebajrang-logo 1.png" alt="HealthApp" />
              <div>
                <div className={styles.clientName}>Shri Bajrang Precast Walls</div>
                <div className={styles.clientIndustry}>Healthcare</div>
              </div>
            </div>
            <p className={styles.testimonialText}>
              "Patient engagement increased by 80% within the first three months
              of launch."
            </p>
            <div className={styles.resultMetric}>
              <div className={styles.metricLabel}>User Growth</div>
              <div className={styles.metricValue}>100K+</div>
            </div>
          </div>

          <div className={styles.testimonialCard}>
            <div className={styles.clientInfo}>
              <TestimonialAvatar src="ProjectsSnapshots/3eSolarVentures/logo.png" alt="FashionStore" />
              <div>
                <div className={styles.clientName}>3e Solar Ventures</div>
                <div className={styles.clientIndustry}>Quotation Generation & Solar Portfolio</div>
              </div>
            </div>
            <p className={styles.testimonialText}>
              "Our conversion rate improved by 45% and sales doubled in six
              months."
            </p>
            <div className={styles.resultMetric}>
              <div className={styles.metricLabel}>Sales Growth</div>
              <div className={styles.metricValue}>+200%</div>
            </div>
          </div>
        </div>
      </section>

      <section className="" style={{ alignItems: 'center', display: 'flex', justifyContent: 'center',padding:'20px 10px' }}>

<CTASection />
</section>

    <Footer/>
    </div>
  );
};

export default WorkPage;
